import React, { useEffect, useRef, useState } from "react"; 
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Flex,
  Text,
  Heading,
  ListItem,
  List,
  Img
} from "@chakra-ui/react";
import bullet from "../../../assets/images/bullet.png";
import UnlockRegistration from "../../../shared/UnlockRegistration/UnlockRegistration";
import {
  COLORS,
  TYPES_OF_COMPETATIVE_METRICS,
} from "../../../constants/metrics";
import { CompetitiveTabs } from "../../../shared/Competitive/CompetitiveTabs";
import PeerMatrix from "../../../components/CompetitiveMap/PeerMatrix";
import RelativeMarketShare from "../../../components/CompetitiveMap/RelativeMarketShare";
import {
  getClientClusterwise,
  getClientZScore,
} from "../../../actions/client/clientActions";
import Variance from "../../../components/CompetitiveMap/Variance";
import Patterns from "../../../components/CompetitiveMap/Patterns";
import ComparisonSet from "../ComparisonSet/ComparisonSet";
import RequestPeer from "../../../components/RequestPeer/RequestPeer";
import RecommendedExperts from "../RecommendedExperts/RecommendedExperts";
import CompetitiveRegisterForm from "./CompetitiveRegisterForm";

const CompetitiveRisk = () => {
  const parentScrollRef = useRef(null);
  const dispatch = useDispatch();
  const RIGHT_INTERPRETATIONS = [
    "align/maintain/manage/ensure/control",
    "focus/develop/invest/implement/conduct",
    "streamline/optimize/support",
    "enhance/improve/increase/srengthen/expand",
    "reduce/minimize/eliminate",
    "negotiate/restructure",
  ];

  const { data: user, isAuthenticatedUser } = useSelector(
    (state) => state.userReducer
  );
  const { loading: clientLoading, data: clientData } = useSelector(
    (state) => state.clientReducer
  );
  const { loading: clientClusterWiseLoading, data: clientClusterWiseData } =
    useSelector((state) => state.clientClusterWiseReducer);

  const [currentCompetativeMetric, setCurrentCompetativeMetric] = useState(
    TYPES_OF_COMPETATIVE_METRICS[0].label
  );
  const [currentMetric, setCurrentMetric] = useState(
    TYPES_OF_COMPETATIVE_METRICS[0].value[0].value[0].value
  );
  const [metricColors, setMetricColors] = useState([]);
  const [currentType, setCurrentType] = useState();
  const [patternData, setPatternData] = useState(null);
  const [patternValue, setPatternValue] = useState([]);
  const [competitiveMenuObjects, setCompetitiveMenuObjects] = useState({});
  const [modelRequestPeer, setModelRequestPeer] = useState(false);
  const [competitiveMenuLabel, setCompetitiveMenuLabel] = useState({});
  const [competitiveTrendLabel, setCompetitiveTrendLabel] = useState({});
  const [showTrendDescription, setShowTrendDescription] = useState(false);
  const [modelRegistrationPopUp, setModelRegistrationPopUp] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [showForm, setShowForm] = useState(!isAuthenticatedUser);

 

  useEffect(() => {
    if (!clientLoading && clientData?._id) {
      dispatch(getClientClusterwise(clientData?._id));
      dispatch(getClientZScore(clientData?._id));
    }
  }, [dispatch, clientLoading]);

  return (
    <Box
      className="competitive-container"
      width="100%"
      minHeight="100vh"
      overflow="hidden"
      position="relative"
      background="#fff"
    >
      <Flex
        id="segment_risk_container"
        direction={{ base: "column", xl: "row" }}
        width="100%"
        height="100%"
        maxW="1980px"
        mx="auto"
      >
        <CompetitiveTabs
          setCurrentCompetativeMetric={setCurrentCompetativeMetric}
          currentCompetativeMetric={currentCompetativeMetric}
          currentMetric={currentMetric}
          setCurrentMetric={setCurrentMetric}
          metricColors={metricColors}
          setCompetitiveMenuLabel={setCompetitiveMenuLabel}
          competitiveMenuObjects={competitiveMenuObjects}
          setCompetitiveMenuObjects={setCompetitiveMenuObjects}
        />

        <Box
          className="segment_risks_block"
          filter={!isAuthenticatedUser ? "blur(8px)" : "none"}
          pointerEvents={!isAuthenticatedUser ? "none" : "auto"}
          width="100%"
        >
          <Box id="activityLabel" fontSize={{ base: "sm", md: "md" }} p={2}>
            {clientClusterWiseLoading
              ? ""
              : `BENCHMARKING WITH ${clientClusterWiseData?.clusterWiseData.length || 0} OTHER SMES`}
          </Box>

          <Flex
            id="segment_risks_content"
            direction={{ base: "column", xl: "row" }}
            width="100%"
            height="100%"
            px={{ base: 2, md: 4, xl: 6 }}
            gap={4}
            pb={{ base: 4, md: 6 }}
          >
            <Box
              id="segment_risks_graph"
              flex="1"
              pr={{ base: 0, xl: 4 }}
              minW={{ base: "100%", xl: "60%" }}
            >
              <Box
                className="activity-content-graph"
                ref={parentScrollRef}
                overflowY="auto"
                maxHeight={{ base: "auto", xl: "calc(100vh - 140px)" }}
                pb={{ base: 4, md: 6 }}
              >
                <Box mb={4}>
                  <ComparisonSet setModelRequestPeer={setModelRequestPeer} />
                </Box>

                <Box mb={4}>
                  <RelativeMarketShare />
                </Box>

                <PeerMatrix
                  patternData={patternData}
                  currentType={currentType}
                  currentMetric={currentMetric}
                  setPatternValue={setPatternValue}
                  competitiveMenuLabel={competitiveMenuLabel}
                />
              </Box>
            </Box>

            {/* Right Panel */}
            <Box
              id="competitive_left"
              width={{ base: "100%", xl: "40%" }}
              minW="320px"
              maxW="600px"
              position="relative"
              overflow="hidden"
              filter={!isAuthenticatedUser && hasInteracted ? "blur(4px)" : "none"}
              display="flex"
              flexDirection="column"
              height="calc(100vh - 100px)"
            >
              <RequestPeer
                setModelRequestPeer={setModelRequestPeer}
                modelRequestPeer={modelRequestPeer}
              />

              <Box flex="1" overflowY="auto">
                <Box boxShadow="0 0 5px 0 rgba(0,0,0,0.2)" bg="#F8F8F8" borderRadius="5px" mb={4}>
                  {competitiveTrendLabel[currentMetric]?.label && (
                    <Flex
                      p="10px"
                      onClick={() => setShowTrendDescription(!showTrendDescription)}
                      cursor="pointer"
                      flexWrap="wrap"
                    >
                      <Text fontSize="16px" fontWeight="600" color="#1E1E1E">
                        When {competitiveMenuLabel[currentMetric]} is
                      </Text>
                      <Text
                        backgroundColor={
                          COLORS[patternData?.interpretation?.color]?.bgColor || "#EAF4EB"
                        }
                        color={
                          COLORS[patternData?.interpretation?.color]?.textColor || "#0D3B14"
                        }
                        ml="2"
                        mt={{ base: 2, md: 0 }}
                        p="0px 10px"
                        borderRadius="5px"
                        textTransform="capitalize"
                      >
                        {competitiveTrendLabel[currentMetric]?.label} -{" "}
                        {competitiveTrendLabel[currentMetric]?.trendCategory}
                      </Text>
                    </Flex>
                  )}

                  {showTrendDescription && (
                    <Box p="5px 10px">
                      <Box width="100%" borderRight="4px solid #F2F7F7" pr={2}>
                        <Heading fontSize="14px" color="#5D5D5D" textTransform="uppercase">
                          Ways To Assess Or Diagnose
                        </Heading>
                        <List spacing={3} mt="2">
                          <ListItem
                            color="#1E1E1E"
                            fontWeight={600}
                            fontSize="12px"
                            display="flex"
                            alignItems="center"
                          >
                            <svg width="12" height="12" viewBox="0 0 26 26" fill="none">
                              <path
                                d="M13 1H2C1.44772 1 1 1.44772 1 2V24C1 24.5523 1.44772 25 2 25H24C24.5523 25 25 24.5523 25 24V13"
                                stroke="black"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                            <Box mr={2}></Box>
                            {patternData?.interpretation?.waysToAssessOrDiagnose || ""}
                          </ListItem>
                        </List>
                      </Box>

                      <Box mt={3}>
                        <Heading fontSize="14px" color="#5D5D5D" textTransform="uppercase">
                          Internal Controls
                        </Heading>
                        <List spacing={3} mt="2">
                          <ListItem
                            color="#1E1E1E"
                            fontWeight={600}
                            fontSize="12px"
                            display="flex"
                            alignItems="center"
                          >
                            <svg width="12" height="12" viewBox="0 0 26 26" fill="none">
                              <path
                                d="M13 1H2C1.44772 1 1 1.44772 1 2V24C1 24.5523 1.44772 25 2 25H24C24.5523 25 25 24.5523 25 24V13"
                                stroke="black"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                            <Box mr={2}></Box>
                            {patternData?.interpretation?.internalControls || ""}
                          </ListItem>
                          {RIGHT_INTERPRETATIONS.map((key) => {
                            const suggestion =
                              patternData?.interpretation?.BusinessCapabilityRecommendation?.[key];
                            return suggestion ? (
                              <ListItem
                                key={key}
                                fontSize="12px"
                                display="flex"
                                alignItems="center"
                              >
                                <Img src={bullet} mr={2} />
                                {key}: {suggestion}
                              </ListItem>
                            ) : null;
                          })}
                        </List>
                      </Box>
                    </Box>
                  )}

                  <RecommendedExperts />
                </Box>

                <Box>
                  <Variance
                    currentType={currentType}
                    currentMetric={currentMetric}
                    metricColors={metricColors}
                    competitiveMenuLabel={competitiveMenuLabel}
                    competitiveMenuObjects={competitiveMenuObjects}
                    currentCompetativeMetric={currentCompetativeMetric}
                  />
                   <Patterns
                  setCurrentType={setCurrentType}
                  currentMetric={currentMetric}
                  setPatternData={setPatternData}
                  setMetricColors={setMetricColors}
                  metricColors={metricColors}
                  setCurrentMetric={setCurrentMetric}
                  parentScrollRef={parentScrollRef}
                  setCompetitiveTrendLabel={setCompetitiveTrendLabel}
                />
                </Box>
              </Box>
            </Box>
          </Flex>
        </Box>
      </Flex>


{showForm && !isAuthenticatedUser && (
  <>
   
<Box
  position="fixed"
  top="15%"
  left={{ base: "0", xl: "260px" }} 
  w={{ base: "100%", xl: "calc(100% - 260px)" }}
  h="100%"
  bg="rgba(0,0,0,0.4)"
  backdropFilter="blur(5px)"
  zIndex={1}
/>


    {/* Form */}
    <Box
      p="15%"
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      zIndex={2}
      width="70%"
    >
      <CompetitiveRegisterForm onClose={() => setShowForm(false)} />
    </Box>
  </>
)}


    </Box>
  );
};

export default CompetitiveRisk;
